// extracted by mini-css-extract-plugin
module.exports = {"container":"Write_container__emI_H","itemA":"Write_itemA__2xymd","itemB":"Write_itemB__WRs0H","itemC":"Write_itemC__M2OoV","itemD":"Write_itemD__14W5o"};